/* Highlights (Pashion): AJAX filter chips.
 *
 * Items with data-filter-params apply their filter through Broadcast's
 * <collection-filters-form> (assets/collection-filters-form.js) instead of
 * navigating: submitForm(null, url) pushes the URL and re-fetches the product
 * grid, sidebar and results count. Chips act like radios within the same
 * filter name, toggle off when active, keep every other filter (size, price,
 * sort) and drop `page=`. Items with data-filter-clear (e.g. "Shop All") clear
 * every filter the same way.
 *
 * Active state (.is-active / aria-pressed) is synced from the URL on load,
 * after every click, on back/forward, and whenever the product grid is
 * re-rendered (sidebar changes push a new URL before the fetch).
 */
!function () {
  'use strict';

  var ACTIVE_CLASS = 'is-active';
  var FILTER_PREFIX = 'filter.';

  function parseParams(str) {
    return new URLSearchParams(str || '');
  }

  function paramsActive(params, current) {
    var any = false;
    var all = true;
    params.forEach(function (value, name) {
      any = true;
      if (current.getAll(name).indexOf(value) === -1) all = false;
    });
    return any && all;
  }

  function hasFilter(current) {
    var found = false;
    current.forEach(function (value, name) {
      if (name.indexOf(FILTER_PREFIX) === 0) found = true;
    });
    return found;
  }

  function stripFilters(current) {
    var names = [];
    current.forEach(function (value, name) {
      if (name.indexOf(FILTER_PREFIX) === 0 || name === 'page') names.push(name);
    });
    names.forEach(function (name) { current.delete(name); });
  }

  function toUrl(url) {
    var search = url.searchParams.toString();
    return url.pathname + (search ? '?' + search : '');
  }

  class PashionHighlights extends HTMLElement {
    constructor() {
      super();
      this.onClick = this.onClick.bind(this);
      this.sync = this.sync.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.onClick);
      window.addEventListener('popstate', this.sync);

      var grid = document.querySelector('[data-products-grid]');
      if (grid && 'MutationObserver' in window) {
        this.observer = new MutationObserver(this.sync);
        this.observer.observe(grid, { childList: true });
      }

      this.sync();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      window.removeEventListener('popstate', this.sync);
      if (this.observer) this.observer.disconnect();
    }

    onClick(event) {
      var link = event.target.closest('a[data-filter-params], a[data-filter-clear]');
      if (!link || !this.contains(link)) return;

      var url = new URL(link.href, window.location.origin);
      /* Start from the current URL so every other filter and the sort survive */
      var next = new URL(window.location.href);
      var current = next.searchParams;

      if (link.hasAttribute('data-filter-clear')) {
        stripFilters(current);
      } else {
        var params = parseParams(link.dataset.filterParams);
        var active = paramsActive(params, current);
        var names = [];
        params.forEach(function (value, name) {
          if (names.indexOf(name) === -1) names.push(name);
        });
        names.forEach(function (name) { current.delete(name); });
        if (!active) {
          params.forEach(function (value, name) { current.append(name, value); });
        }
        current.delete('page');
      }

      /* A chip pointing at another collection stays a normal link */
      if (url.pathname !== next.pathname) return;

      event.preventDefault();

      var target = toUrl(next);
      var form = document.querySelector('collection-filters-form');
      var grid = document.querySelector('[data-products-grid]');

      if (form && typeof form.submitForm === 'function' && grid) {
        form.submitForm(null, target);
        this.sync();
      } else {
        window.location.href = target;
      }
    }

    sync() {
      var current = new URL(window.location.href).searchParams;
      var anyFilter = hasFilter(current);

      this.querySelectorAll('[data-filter-params]').forEach(function (link) {
        var on = paramsActive(parseParams(link.dataset.filterParams), current);
        link.classList.toggle(ACTIVE_CLASS, on);
        link.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      this.querySelectorAll('[data-filter-clear]').forEach(function (link) {
        link.classList.toggle(ACTIVE_CLASS, !anyFilter);
        link.setAttribute('aria-pressed', anyFilter ? 'false' : 'true');
      });

      document.dispatchEvent(new CustomEvent('theme:highlights:updated', { bubbles: true }));
    }
  }

  if (!customElements.get('pashion-highlights')) {
    customElements.define('pashion-highlights', PashionHighlights);
  }
}();
